import React from "react";
import Alert from "@amzn/meridian/esm/components/alert";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Link from "@amzn/meridian/esm/components/link";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";

import zoomSdk from "@zoom/appssdk";
import star from "../../images/star.svg";
import star_fallback from "../../images/star_fallback.png";
import LogManager from "../utils/LogManager";
import { TRANSCRIPT_NOT_AVAILABLE_MESSAGE } from "../../constants";

/**
 * This component is shown when transcription is not available for the current meeting.
 * This view appears for hosts in meetings marked as not eligible by the `/is-aims-available` API.
 *
 * - It informs the user that the transcription feature is not approved for this meeting.
 * - It provides a "Learn more" link that opens a wiki page
 */

const TranscriptNotAvailable = () => {
  const handleLearnMoreClick = async () => {
    try {
      await zoomSdk.openUrl({
        url: "https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS",
      });
    } catch (error) {
      console.error("Failed to open URL in Zoom:", error);
      LogManager.error("Failed to open URL in Zoom:", error);
    }
  };

  return (
    <Column spacing="none" spacingInset="none">
      <Column height="40px" />
      <Column height="100px">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: "#FFFFFF" }}>
            <Box type="outline" spacingInset="none" width="68px" height="20px"></Box>
          </Theme>
          <Box type="outline" spacingInset="none" width="226px" height="100px">
            <Row spacing="none" spacingInset="none">
              <Row spacing="none" spacingInset="none" width="16px" />
              <Column spacing="none" spacingInset="none" width="24px" height="100px">
                <Column spacing="none" spacingInset="none" height="16px" />
                <img src={star} alt="star"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = star_fallback;
                  }}
                />
              </Column>
              <Row spacing="none" spacingInset="none" width="20px" />
              <Column spacing="none" spacingInset="none" width="133px" height="100px">
                <Column spacing="none" spacingInset="none" height="17px" />
                <Text fontFamily="amazonEmber" type="h50" alignment="start">
                  Transcribe meeting
                </Text>
                <Column spacing="none" spacingInset="none" height="16px" />
                <Alert type="warning" size="small">
                  Not available
                </Alert>
              </Column>
            </Row>
          </Box>
        </Row>
      </Column>

      <Column height="16px" />

      <Row spacing="none">
        <Row width="72px" />
        <Text fontFamily="amazonEmber" type="h50" color="secondary" alignment="start">
          Start taking notes
        </Text>
      </Row>

      <Column height="16px" />

      <Row spacing="none">
        <Row width="72px" />
        <Box spacingInset="none" maxWidth="226px">
          <Text type="b200" color="secondary">
            {TRANSCRIPT_NOT_AVAILABLE_MESSAGE}
          </Text>
        </Box>
      </Row>
      <Column height="16px"></Column>

      <Row spacing="none">
        <Row width="72px" />
        <Link onClick={handleLearnMoreClick} type="secondary">
          <Theme tokens={{ textColorPrimary: "#006D5B" }}>
            <Text color="primary" type="b200" fontFamily="amazonEmber">
              <u>Learn more</u>
            </Text>
          </Theme>
        </Link>
      </Row>
    </Column>
  );
};

export default TranscriptNotAvailable;
